import { ens_normalize } from '@adraffy/ens-normalize';
export function normalize(name) {
    return ens_normalize(name);
}
//# sourceMappingURL=normalize.js.map